import React, { useContext, useEffect, useState } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './footer.css'
import axios from 'axios'
import { AudioPlayerContext } from '../AudioFiles/AudioPlayerContext'
const Footer = () => {
  const {
    showPlayer,
  } = useContext(AudioPlayerContext);
  const [categories, setCategories] = useState([])
  useEffect(() => {
    categoryData()
    getPages();
  }, [])
  const categoryData = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/categories`,
      headers: {
        'Authorization': localStorage.getItem('dastaan__token'),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    };
    axios.request(config).then((response) => {
      setCategories(response.data.categories)
    })
  }
  const [about, setAbout] = useState('')
  const [terms, setTermsCondition] = useState('')
  const [contact, setContactUs] = useState('')
  const [refund, setRefund] = useState('')
  const [grievance, setGrievance] = useState('')
  const [privacy, setPrivacy] = useState('')
  const getPages = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/pages`,
      headers: {
        'Authorization': localStorage.getItem('dastaan__token'),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    };
    axios.request(config).then((response) => {
      const data = response.data.data
      data.map((item) => {
        switch (item.page_name) {
          case "Terms and Condition":
            setTermsCondition(`pages/${item.page_name}`)
            break;
          case "About Us":
            setAbout(`pages/${item.page_name}`)
            break;
          case "Contact Us":
            setContactUs(`pages/${item.page_name}`)
            break;
          case "Refund Policy":
            setRefund(`pages/${item.page_name}`)
            break;
          case "Grievance Policy":
            setGrievance(`pages/${item.page_name}`)
            break;
          case "Privacy Policy":
            setPrivacy(`pages/${item.page_name}`)
            break;
        }
      })
    })
  }
  const w = window.innerWidth
  return (
    <>
      {
        w > 768 ? (
          /* desktop */
          <>
            <Col md={12} xl={12} className='mt-2'>
              <hr />
            </Col>
            <Container className='main-footer'>
              <Row>
                <Col md={2} xl={2} className='ml-5'>
                  <Image src={`${process.env.PUBLIC_URL}/logo/dastaan_logo.jpg`} className='logo footer-logo' alt="logo" title="Dastaan" />
                </Col>
                <Col md={10} style={{ marginTop: "-40px" }} >
                  <div className='footer-page-links'>
                    <small className='desktop-footer-text'>
                      <Link to={about} className='text-white'>About us</Link>
                    </small> &nbsp;&nbsp;
                    <small className='desktop-footer-text'>
                      <Link to={contact} className='text-white'>Contact us</Link>
                    </small> &nbsp;&nbsp;
                    <small className='desktop-footer-text'>
                      <Link to={terms} className='text-white'>Terms and Condition</Link>
                    </small> &nbsp;&nbsp;
                    <small className='desktop-footer-text'>
                      <Link to={refund} className='text-white'>Refund Policy</Link>
                    </small> &nbsp;&nbsp;
                    <small className='desktop-footer-text'>
                      <Link to={grievance} className='text-white'>Grievance Policy</Link>
                    </small> &nbsp;&nbsp;
                    <small className='desktop-footer-text'>
                      <Link to={privacy} className='text-white'>Privacy Policy</Link>
                    </small>
                  </div>
                </Col>
              </Row>
            </Container>
            <hr className='mt-2' />
            <Col md={12} xs={12} className=' text-center'>
              <small className='copywright '>© copyright 2025, All Rights Reseversed by Dastaan </small>
            </Col>
          </>) : (
          /* mobile */
          <>
            <Col md={12} xl={12} className='mt-2'>
              <div className='horizontal-line'></div>
            </Col>
            <Container className='mt-5' style={{ paddingBottom: showPlayer === true && "20%" }} >
              <Row className=''>
                <Col xs={12} className='mt-2'>
                  <Image src={`${process.env.PUBLIC_URL}/logo/dastaan_logo.jpg`} className='logo' alt="logo" title="Dastaan" />
                </Col>
                <Col xs={6} className='mt-10'>
                  <span><b>Company</b></span>
                  <br />
                  <br />
                  <small>
                    <Link to={about} className='text-white'>About us</Link>
                  </small>
                  <br />
                  <small>
                    <Link to={contact} className='text-white'>Contact us</Link>
                  </small>
                </Col>
                <Col xs={6} className='mt-10'>
                  <span><b>LEGAL</b></span>
                  <br />
                  <br />
                  <small>
                    <Link to={terms} className='text-white'>Terms & Condition</Link> <br />
                    <Link to={refund} className='text-white'>Refund Policy</Link> <br />
                    <Link to={privacy} className='text-white'>Privacy Policy</Link> <br />
                    <Link to={grievance} className='text-white'>Grievance Policy</Link>
                  </small>
                </Col>
                <Col md={12} xs={12} className='mt-10 text-center'>
                  <small className='copywright '>© copyright 2025, All Rights Reseversed by Dastaan </small>
                </Col>
              </Row>
            </Container>
          </>
        )
      }
    </>
  )
}
export default Footer